var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(-771 -383.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16192",
    "data-name": "Group 16192",
    transform: "translate(771 383.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16191",
    "data-name": "Group 16191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10095",
    "data-name": "Path 10095",
    d: "M7.5,0A7.5,7.5,0,1,0,15,7.5,7.5,7.5,0,0,0,7.5,0Zm0,13.828A6.328,6.328,0,1,1,13.828,7.5,6.325,6.325,0,0,1,7.5,13.828Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16194",
    "data-name": "Group 16194",
    transform: "translate(777.912 389.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16193",
    "data-name": "Group 16193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10096",
    "data-name": "Path 10096",
    d: "M236.588,214.33a.588.588,0,0,0-.588.588V218.7a.588.588,0,1,0,1.175,0v-3.784A.588.588,0,0,0,236.588,214.33Z",
    transform: "translate(-236 -214.33)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16196",
    "data-name": "Group 16196",
    transform: "translate(777.707 387.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16195",
    "data-name": "Group 16195"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 0.793,
    cy: 0.793,
    r: 0.793,
    fill: "currentColor"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.458188cb1aba71236e949034dc29fbd6.svg";
export { ForwardRef as ReactComponent };